export const CurrencyName = {
  integerValue: 'JOY',
} as const

export { ED, BN_ZERO, JOY_DECIMAL_PLACES } from '@/common/constants'
